/**
 * Callhome API factory function
 */

import { CallhomeApi as CallhomeApiClient } from '@solink/vd-data-layer/api-clients/callhome/callhome';
import { AuthenticatedRequestor } from '@solink/vd-data-layer/api-clients/shared/AuthenticatedRequestor';

import settings from '@solinkcorp/settings';
import * as constants from 'vd-constants';
import AuthService from '../models/AuthService';

/**
 * Create a new Callhome API instance with the provided auth token.
 */
function CallhomeApi(authToken: string): CallhomeApiClient;

/**
 * Creates a new Callhome Api Instance with the appropriate AuthToken
 * @deprecated pass in auth token instead.
 */
function CallhomeApi(params?: { impersonate?: boolean }): CallhomeApiClient;

function CallhomeApi(params: string | { impersonate?: boolean } | undefined): CallhomeApiClient {
  let authToken: string | undefined;
  if (typeof params === 'string') {
    authToken = params;
  } else if (params?.impersonate) {
    authToken = AuthService.impersonator?.authToken;
  } else {
    authToken = AuthService.authToken;
  }

  if (!authToken) {
    throw new Error(`Can't make Callhome API requests when not logged in.`);
  }

  return new CallhomeApiClient(
    new AuthenticatedRequestor(
      `${settings.callhome_url}/api`,
      constants.REQUEST_TIMEOUT,
      authToken,
    ),
  );
}

export default CallhomeApi;
